import React from 'react'
import { RadioGroup, Radio } from 'react-radio-group'
import Select from 'react-select'
import ReactHtmlParser from 'html-react-parser'
import { generateUUID } from '../../../../utils'

class DropdownRadio extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedRadio: '',
      selectedDropdown: ''
    }
    this.handleRadioChange = this.handleRadioChange.bind(this)
    this.handleDropdownChange = this.handleDropdownChange.bind(this)
  }

  componentDidMount() {
    const { rawAnswers, storeAnswer, index } = this.props
    if (rawAnswers) {
      this.setState(rawAnswers)
    } else {
      storeAnswer(index, this.state)
    }
  }

  handleRadioChange(selected) {
    const { storeAnswer, checkSurveyState, index } = this.props
    this.setState({ selectedRadio: selected }, () => {
      storeAnswer(index, this.state)
      checkSurveyState(this)
    })
  }

  handleDropdownChange(e) {
    const { storeAnswer, checkSurveyState, index } = this.props
    this.setState({ selectedDropdown: e.value }, () => {
      storeAnswer(index, this.state)
      checkSurveyState(this)
    })
  }

  render() {
    const { radio, question, dropdown, className } = this.props
    const optionsFormatted = []
    dropdown.options.forEach(option => {
      optionsFormatted.push({ value: option, label: option })
    })

    return (
      <div className={`${className}`}>
        <div className="surveys-intro row collapse">
          <div className="small-12 columns">
            <h3>{ReactHtmlParser(question)}</h3>
          </div>
        </div>
        <div className="row surveys-container collapse">
          <div className="surveys-list small-12 columns">
            <div className={`survey-label survey-item-${dropdown.size}`}>
              {dropdown.label}
            </div>

            <br />
            <Select
              options={optionsFormatted}
              className={`survey-dropdown survey-item-${dropdown.size}`}
              onChange={this.handleDropdownChange}
              value={this.state.selectedDropdown}
              clearable={false}
              searchable={dropdown.searchable}
              required
            />
            <br />
            <br />
            <br />
            <div className={`survey-label survey-item-${radio.size}`}>
              {radio.label}
            </div>
            <br />
            <RadioGroup
              selectedValue={this.state.selectedRadio}
              name={`radio-dropdown-${this.props.index}`}
              onChange={this.handleRadioChange}
            >
              {radio.options.map((input, index) => {
                const UUID = generateUUID()
                const required = index === 0

                return (
                  <div className="survey-radio" key={index}>
                    <Radio required={required} id={UUID} value={input} />
                    <label htmlFor={UUID}>{input}</label>
                  </div>
                )
              })}
            </RadioGroup>
          </div>
        </div>
      </div>
    )
  }
}

export default DropdownRadio
